import { VerticalSpace } from '@brokerbay/design-components';
import { INotificationSettings } from '@bb/users';
import { Space, Switch, Text, theme } from 'components';
import React from 'react';
import BasicCard from './BasicCard';

type ChatMessagesCardProps = {
  handleChange: (changes: Partial<INotificationSettings>) => void;
  modifiedNotifications: INotificationSettings;
};

const ChatMessagesCard: React.FC<ChatMessagesCardProps> = ({
  handleChange,
  modifiedNotifications,
}) => (
    <BasicCard
      title="Chat Messages"
      bodyStyle={{ paddingTop: 0, marginTop: `-${theme.paddingXs}` }}
      headStyle={{ paddingBottom: 0 }}
    >
      <VerticalSpace size="small">
        <Text>Configure how you want to be notified of chat messages:</Text>
        <VerticalSpace size={0}>
          <Space size={0}>
            <Switch
              data-cy="chat-messages-email"
              size="small"
              checked={modifiedNotifications.officeMessages.frontDesk.email}
              onChange={checked =>
                handleChange({
                  officeMessages: {
                    ...modifiedNotifications.officeMessages,
                    frontDesk: {
                      ...modifiedNotifications.officeMessages.frontDesk,
                      email: checked,
                    },
                  },
                })
              }
            />{' '}
            Email
          </Space>
          <Space size={0}>
            <Switch
              data-cy="chat-messages-sms"
              size="small"
              checked={modifiedNotifications.officeMessages.frontDesk.text}
              onChange={checked =>
                handleChange({
                  officeMessages: {
                    ...modifiedNotifications.officeMessages,
                    frontDesk: {
                      ...modifiedNotifications.officeMessages.frontDesk,
                      text: checked,
                    },
                  },
                })
              }
            />{' '}
            SMS
          </Space>
        </VerticalSpace>
      </VerticalSpace>
    </BasicCard>
  );

export default ChatMessagesCard;
